import { useEffect } from "react";

import DATA_LAYER_SCOPES from "seneca-common/features/analytics/dataLayerScopes";
import { pushGlobalValuesToDataLayer } from "seneca-common/features/analytics/gtm";

import { Data } from "../../common";

type UserScopeKeys = "isFirstUserSession";

export function usePushToDataLayerUserScope<T extends Data>(
  key: UserScopeKeys,
  value: T
) {
  useEffect(() => {
    pushGlobalValuesToDataLayer({
      [DATA_LAYER_SCOPES.USER]: {
        [key]: value
      }
    });
  }, [key, value]);
}
